import React, { useState, useRef } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Login from '../../components/Login/Login'
import './Subscription.css'

function Subscription() {
  const [selectedPlan, setSelectedPlan] = useState('quarterly')
  const [loading, setLoading] = useState(false)
  const [discountCode, setDiscountCode] = useState('')
  const [appliedDiscount, setAppliedDiscount] = useState(null)
  const [checkingDiscount, setCheckingDiscount] = useState(false)
  const loginRef = useRef()

  const plans = {
    monthly: { name: 'ماهانه', price: 110000, discount: '', badge: '', days: 30 },
    quarterly: { name: 'سه ماهه', price: 275000, discount: 'معادل 2 هفته رایگان', badge: 'محبوب‌ترین', days: 90 },
    semiannual: { name: 'شش ماهه', price: 550000, discount: 'معادل 1 ماه رایگان', badge: 'بیشترین صرفه‌جویی', days: 180 }
  }

  // محاسبه قیمت با تخفیف
  const getDiscountedPriceForPlan = (planPrice) => {
    if (!appliedDiscount) return planPrice;
    const discounted = planPrice - (planPrice * appliedDiscount.discountPercent / 100);
    return Math.round(discounted);
  };

  // اعتبارسنجی کد تخفیف
  const validateDiscount = async () => {
    if (!discountCode.trim()) {
      toast.error('لطفاً کد تخفیف را وارد کنید');
      return;
    }
    
    setCheckingDiscount(true);
    try {
      const response = await axios.get(`https://api.chekidesara.ir/api/discount-codes/validate/${discountCode}?plan=${selectedPlan}`);
      
      if (response.data.success) {
        setAppliedDiscount(response.data.data);
        toast.success(`کد تخفیف اعمال شد! ${response.data.data.discountPercent}% تخفیف`);
      } else {
        toast.error(response.data.message);
        setAppliedDiscount(null);
      }
    } catch (error) {
      console.error('❌ خطا در اعتبارسنجی کد تخفیف:', error);
      toast.error('خطا در اعتبارسنجی کد تخفیف');
      setAppliedDiscount(null);
    } finally {
      setCheckingDiscount(false);
    }
  };

  // حذف کد تخفیف
  const removeDiscount = () => {
    setAppliedDiscount(null);
    setDiscountCode('');
    toast.success('کد تخفیف حذف شد');
  };

  // ========== تابع اصلی پرداخت (اصلاح‌شده) ==========
  const handleSubscribe = async (planKey) => {
    // ========== استفاده از planKey که به تابع داده شده ==========
    const currentPlan = planKey || selectedPlan;
    
    setLoading(true)
    
    try {
      // ========== دریافت اطلاعات پلن ==========
      const planData = plans[currentPlan];
      if (!planData) {
        toast.error('پلن انتخاب شده معتبر نیست');
        setLoading(false);
        return;
      }
      
      const selectedPrice = planData.price;
      const selectedName = planData.name;
      const finalPrice = getDiscountedPriceForPlan(selectedPrice);
      
      console.log('📊 خلاصه پرداخت:');
      console.log(`   پلن انتخاب شده: ${currentPlan}`);
      console.log(`   نام پلن: ${selectedName}`);
      console.log(`   قیمت پایه: ${selectedPrice.toLocaleString()} تومان`);
      console.log(`   قیمت نهایی: ${finalPrice.toLocaleString()} تومان`);
      
      // ========== ذخیره در localStorage ==========
      localStorage.setItem('temp_plan', currentPlan);
      localStorage.setItem('temp_days', planData.days);
      if (appliedDiscount) {
        localStorage.setItem('temp_discount', JSON.stringify(appliedDiscount));
      }
      
      // ========== بررسی لاگین ==========
      const userData = localStorage.getItem('currentUser');
      if (!userData) {
        toast.error('لطفاً ابتدا وارد شوید');
        if (loginRef.current) {
          loginRef.current.openModal();
        }
        setLoading(false);
        return;
      }
      
      const user = JSON.parse(userData);
      
      // ========== محاسبه مبلغ به ریال ==========
      const amountInRials = Math.round(finalPrice * 10);
      
      // ========== ارسال به سرور ==========
      const requestData = {
        amount: amountInRials,
        originalPrice: selectedPrice,
        finalPriceTomans: finalPrice,
        description: `خرید اشتراک ${selectedName} - کاربر: ${user.email}`,
        userId: user._id,
        userEmail: user.email,
        plan: currentPlan,
        days: planData.days,
        discountCode: appliedDiscount?.code || null,
        discountPercent: appliedDiscount?.discountPercent || null
      };
      
      console.log('📤 ارسال به سرور:', requestData);
      
      const response = await axios.post(`https://api.chekidesara.ir/api/payment/request`, requestData);
      
      if (response.data.success) {
        console.log('✅ هدایت به درگاه پرداخت...');
        window.location.href = response.data.paymentUrl;
      } else {
        toast.error(response.data.message || 'خطا در اتصال به درگاه پرداخت');
      }
    } catch (error) {
      console.error('❌ Payment error:', error);
      toast.error(error.response?.data?.message || 'خطا در ارتباط با سرور');
    } finally {
      setLoading(false);
    }
  }

  const hasDiscount = appliedDiscount !== null

  return (
    <>
      <Navbar />
      
      <main className="subscription-page">
        <div className="container">
          
          <div className="pricing-header">
            <h1>چکیده‌سرا</h1>
            <p className="header-subtitle">
              زمان خود را صرف خواندن نکات کلیدی کنید، نه گم شدن در حاشیه کتاب‌ها.
            </p>
            <p className="header-description">
              هر خلاصه در «چکیده‌سرا» تمام نکات اصلی کتاب اصلی را بدون کم و کاست منتقل می‌کند.
              <br />
              دیگر هیچ بهانه‌ای برای نخواندن کتاب‌های بزرگ انگلیسی ندارید.
            </p>
          </div>

          {/* بخش کد تخفیف */}
          <div className="discount-section">
            <div className="discount-input-group">
              <input 
                type="text" 
                className="discount-input" 
                placeholder="کد تخفیف خود را وارد کنید"
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value.toUpperCase())}
                disabled={appliedDiscount !== null}
              />
              {!appliedDiscount ? (
                <button 
                  className="discount-btn" 
                  onClick={validateDiscount}
                  disabled={checkingDiscount}
                >
                  {checkingDiscount ? 'در حال بررسی...' : 'اعمال کد'}
                </button>
              ) : (
                <button className="discount-remove-btn" onClick={removeDiscount}>
                  حذف کد
                </button>
              )}
            </div>
            {appliedDiscount && (
              <div className="discount-info success">
                کد تخفیف {appliedDiscount.discountPercent}% اعمال شد
              </div>
            )}
          </div>

          <div className="pricing-grid">
            {/* کارت ماهانه */}
            <div 
              className={`pricing-card ${selectedPlan === 'monthly' ? 'selected' : ''}`} 
              onClick={() => setSelectedPlan('monthly')}
            >
              <h3 className="plan-name">{plans.monthly.name}</h3>
              <div className="plan-price">
                {hasDiscount && selectedPlan === 'monthly' ? (
                  <>
                    <span className="old-price">{plans.monthly.price.toLocaleString()}</span>
                    <span className="new-price">{Math.round(getDiscountedPriceForPlan(plans.monthly.price)).toLocaleString()} <span>تومان</span></span>
                  </>
                ) : (
                  <>{plans.monthly.price.toLocaleString()} <span>تومان</span></>
                )}
              </div>
              {hasDiscount && selectedPlan === 'monthly' && (
                <div className="plan-discount">تخفیف {appliedDiscount.discountPercent}%</div>
              )}
              <button 
                className="plan-btn" 
                onClick={(e) => { 
                  e.stopPropagation(); 
                  setSelectedPlan('monthly');
                  handleSubscribe('monthly'); // ← ارسال مستقیم plan
                }}
                disabled={loading}
              >
                {loading && selectedPlan === 'monthly' ? 'در حال اتصال...' : 'خرید'}
              </button>
            </div>

            {/* کارت سه ماهه */}
            <div 
              className={`pricing-card popular ${selectedPlan === 'quarterly' ? 'selected' : ''}`} 
              onClick={() => setSelectedPlan('quarterly')}
            >
              <div className="card-badge popular-badge">محبوب‌ترین</div>
              <h3 className="plan-name">{plans.quarterly.name}</h3>
              <div className="plan-price">
                {hasDiscount && selectedPlan === 'quarterly' ? (
                  <>
                    <span className="old-price">{plans.quarterly.price.toLocaleString()}</span>
                    <span className="new-price">{Math.round(getDiscountedPriceForPlan(plans.quarterly.price)).toLocaleString()} <span>تومان</span></span>
                  </>
                ) : (
                  <>{plans.quarterly.price.toLocaleString()} <span>تومان</span></>
                )}
              </div>
              <div className="plan-discount">{plans.quarterly.discount}</div>
              {hasDiscount && selectedPlan === 'quarterly' && (
                <div className="plan-discount">+ تخفیف {appliedDiscount.discountPercent}% ویژه</div>
              )}
              <button 
                className="plan-btn primary" 
                onClick={(e) => { 
                  e.stopPropagation(); 
                  setSelectedPlan('quarterly');
                  handleSubscribe('quarterly'); // ← ارسال مستقیم plan
                }}
                disabled={loading}
              >
                {loading && selectedPlan === 'quarterly' ? 'در حال اتصال...' : 'خرید'}
              </button>
            </div>

            {/* کارت شش ماهه */}
            <div 
              className={`pricing-card ${selectedPlan === 'semiannual' ? 'selected' : ''}`} 
              onClick={() => setSelectedPlan('semiannual')}
            >
              <div className="card-badge">{plans.semiannual.badge}</div>
              <h3 className="plan-name">{plans.semiannual.name}</h3>
              <div className="plan-price">
                {hasDiscount && selectedPlan === 'semiannual' ? (
                  <>
                    <span className="old-price">{plans.semiannual.price.toLocaleString()}</span>
                    <span className="new-price">{Math.round(getDiscountedPriceForPlan(plans.semiannual.price)).toLocaleString()} <span>تومان</span></span>
                  </>
                ) : (
                  <>{plans.semiannual.price.toLocaleString()} <span>تومان</span></>
                )}
              </div>
              <div className="plan-discount">{plans.semiannual.discount}</div>
              {hasDiscount && selectedPlan === 'semiannual' && (
                <div className="plan-discount">+ تخفیف {appliedDiscount.discountPercent}% ویژه</div>
              )}
              <button 
                className="plan-btn" 
                onClick={(e) => { 
                  e.stopPropagation(); 
                  setSelectedPlan('semiannual');
                  handleSubscribe('semiannual'); // ← ارسال مستقیم plan
                }}
                disabled={loading}
              >
                {loading && selectedPlan === 'semiannual' ? 'در حال اتصال...' : 'خرید'}
              </button>
            </div>
          </div>

          <div className="faq-section">
            <h2>سوالات متداول</h2>
            
            <div className="faq-item">
              <h3>آیا خلاصه‌ها واقعاً نکات اصلی را دارند؟</h3>
              <p>بله. هر خلاصه توسط تیم چکیده سرا بازبینی می‌شود و ساختار و مفاهیم کلیدی کتاب اصلی حفظ می‌گردد.</p>
            </div>

            <div className="faq-item">
              <h3>بعد از خرید چطور شروع کنم؟</h3>
              <p>کافیست وارد سایت شوی. دسترسی ات به تمام خلاصه‌ها و ترجمه لحظه‌ای بلافاصله فعال می‌شود.</p>
            </div>

            <div className="faq-item">
              <h3>روش‌های پرداخت چیست؟</h3>
              <p>پرداخت از طریق درگاه امن زرین‌پال و با تمام کارت‌های عضو شتاب امکان‌پذیر است.</p>
            </div>
          </div>

        </div>
      </main>

      <Footer />
      
      <Login ref={loginRef} onSuccess={() => {
        handleSubscribe(selectedPlan)
      }} />
    </>
  )
}

export default Subscription